import styled from 'styled-components';

export const ActionContainer = styled.div`
  display: flex;
  height: 60px;
  padding: var(--layout-sandgrain) var(--layout-stamp);
  justify-content: center;
  align-items: center;
  gap: var(--layout-stamp);
`;

export const TopBarExternalLink = styled.a`
  color: var(--base-text-primary);
  font: var(--body-sm-medium);
  display: inline-block;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-r-stamp);
  &:focus-visible {
    outline: var(--border-b-stamp) solid var(--control-border-focus-ring);
  }
  &:hover {
    background-color: var(--control-bg-decorative-hover);
  }
`;
